const Home = () => import('../pages/home').then(m => m.default || m)
const AgeVerification = () => import('../pages/ageVerification').then(m => m.default || m)

const Trck = () => import('../pages/trck').then(m => m.default || m)
const Access = () => import('../pages/access').then(m => m.default || m)
const processCallback = () => import('../pages/processCallback').then(m => m.default || m)

const Login = () => import('../pages/auth/login').then(m => m.default || m)
const Blocked = () => import('../pages/errors/blocked').then(m => m.default || m)

const Settings = () => import('../pages/settings/index').then(m => m.default || m)
const SettingsSubscriptions = () => import('../pages/settings/subscriptions').then(m => m.default || m)

const VideosIndex = () => import('../pages/videos/index').then(m => m.default || m)
const Category = () => import('../pages/videos/category').then(m => m.default || m)
const VideosCategory  = () => import('../pages/videos/categories').then(m => m.default || m)
const VideosNew  = () => import('../pages/videos/new').then(m => m.default || m)
const VideosPreview  = () => import('../pages/videos/preview').then(m => m.default || m)

const CookiesPolicy    = () => import('../pages/CookiesPolicy').then(m => m.default || m)
const TEC = () => import('../pages/tec/index').then(m => m.default || m)

const Subscribe = () => import('../pages/subscribe/index').then(m => m.default || m)
const Welcome = () => import('../pages/subscribe/welcome').then(m => m.default || m)
const Unsubscribed = () => import('../pages/subscribe/unsubscribed').then(m => m.default || m)

const Contacto = () => import('../pages/contact/index').then(m => m.default || m)

const Lang = () => import('../pages/lang').then(m => m.default || m)


export default [
    {path: '/', name: 'home', component: Home},
    {path: '/ageVerification', name: 'ageVerification', component: AgeVerification},

    {path: '/trck', name: 'trck', component: AgeVerification},
    {path: '/access/:service/:subscriptionId', name: 'access', component: AgeVerification},
    {path: '/access/:subscriptionId', name: 'access', component: AgeVerification},
    {path: '/subscription/process/:guard/:redirect', name: 'processCallbackRedirect', component: processCallback},
    {path: '/subscription/process/:guard', name: 'processCallback', component: processCallback},

    {path: '/login', name: 'login', component: Login},
    {path: '/blocked', name: 'blocked', component: Blocked},
    
    {
        path: '/settings', component: Settings, children: [
            {path: '', redirect: {name: 'settings.profile'}},
        ]
    },

    {path: '/subscriptions', name: 'subscriptions', component: SettingsSubscriptions},

    {path: '/video/new-content', name: 'videos.new', component: VideosNew},
    {path: '/video/', name: 'videos.index', component: VideosIndex},
    {path: '/video/category/:slug', name: 'videos.gategory.slug', component: Category},
    {path: '/video/categories', name: 'videos.gategory', component: VideosCategory},
    {path: '/video/preview/:slug', name: 'videos.preview', component: VideosPreview},

    {path: '/cookies-policy', name: 'cookies-policy', component: CookiesPolicy},
    {path: '/pages/tec', name: 'tec', component: TEC},

    {path: '/cancel-subscription', name: 'cancel-subscription', component: Subscribe},
    {path: '/welcome', name: 'welcome', component: Welcome},
    {path: '/unsubscribed', name: 'unsubscribed', component: Unsubscribed},

    {path: '/pages/contact', name: 'contact', component: Contacto},

    {path: '/lang/:slug/:lang', name: 'lang', component: Lang},

    {path: '*', name: '404', component: require('../pages/errors/404.vue')},
    {path: '/waiting', name: 'waiting', component: require('../pages/errors/waiting.vue')}
]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js